var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.403%",
    y1: "23.637%",
    x2: "82.176%",
    y2: "78.438%",
    id: "q520ki98ka"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753CBE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB9EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.403%",
    y1: "23.601%",
    x2: "82.176%",
    y2: "78.477%",
    id: "5e56i4szyb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753CBE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB9EE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m98.854 86.826-22.41-22.41c-1.183-1.183-3.825-1.459-5.284 0l-.729.73-11.45-11.45C69.875 40 68.185 20.183 55.13 8.53 42.073-3.122 22.192-2.558 9.818 9.816-2.556 22.19-3.12 42.071 8.532 55.127c11.653 13.056 31.47 14.746 45.166 3.852l11.45 11.45-.728.73a3.731 3.731 0 0 0 0 5.283l22.41 22.41c1.183 1.183 3.825 1.46 5.284 0l6.74-6.742a3.731 3.731 0 0 0 0-5.284zM33.172 61.215c-13.379-.003-24.893-9.456-27.5-22.578C3.065 25.515 10.09 12.378 22.452 7.26c12.36-5.117 26.615-.79 34.045 10.336 7.43 11.126 5.967 25.95-3.495 35.409a28.035 28.035 0 0 1-19.83 8.209z",
    fill: "url(#q520ki98ka)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 23.836c-.968-.968-2.722-.786-3.51 0l-5.82 5.828-5.823-5.823a2.483 2.483 0 0 0-3.51 0c-.968.97-.785 2.724 0 3.51l5.827 5.817-5.826 5.825a2.48 2.48 0 0 0 0 3.509c.968.968 2.724.785 3.509 0l5.823-5.823 5.823 5.821c.969.968 2.54.968 3.509 0 .968-.97.785-2.724 0-3.51l-5.823-5.822 5.821-5.823a2.48 2.48 0 0 0 0-3.51z",
    fill: "url(#5e56i4szyb)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.dfc48cfc4249e1a8f5e6b48cdd4a0b95.svg";
export { ForwardRef as ReactComponent };